import { useCallback } from 'react'
import { useMutation } from '@tanstack/react-query'

import { IncomeService } from '@/api/services/IncomeService'
import { apiErrorMessage } from '@/utils/apiError'

// Triggers FHS income detection for the given customer. Once the primary and recurring income
// tables read from the API, invalidate their queries on success so they pick up what FHS found;
// they are still on sample data, so there is nothing to refresh yet.
export const useIncomeDetection = () => {
  const mutation = useMutation<void, unknown, string>({
    mutationFn: userId => IncomeService.triggerIncomeDetection(userId),
  })
  const { mutateAsync } = mutation

  // Rejects with the gateway's message, so callers can show it as-is.
  const detect = useCallback(
    async (userId: string) => {
      try {
        await mutateAsync(userId)
      } catch (error) {
        throw new Error(apiErrorMessage(error))
      }
    },
    [mutateAsync]
  )

  return { detect, isDetecting: mutation.isPending }
}
